import { call, put, takeEvery } from "redux-saga/effects";

// Action Types
import { DELETE_DELIVERY_CONFIGURATION, GET_DELIVERY_CONFIGURATION, SET_DELIVERY_CONFIGURATION } from "./actionTypes";

// Action Creators
import {
    getDeliveryConfigurationSuccess,
    getDeliveryConfigurationFail,
    setDeliveryConfigurationSuccess,
    setDeliveryConfigurationFail,
    deleteDeliveryConfigurationSuccess,
    deleteDeliveryConfigurationFail,
} from "./actions";

// Helper functions
import { getDeliveryConfiguration, setDeliveryConfiguration as setConfig, deleteDeliveryConfiguration as deleteConfig } from "../../helpers/backend_helper";

function* fetchDeliveryConfiguration() {
    try {
        const response = yield call(getDeliveryConfiguration);
        yield put(getDeliveryConfigurationSuccess(response));
    } catch (error) {
        yield put(getDeliveryConfigurationFail(error));
    }
}

function* setDeliveryConfiguration({ payload }) {
    try {
        const response = yield call(setConfig, payload);
        yield put(setDeliveryConfigurationSuccess(response));
    } catch (error) {
        yield put(setDeliveryConfigurationFail(error));
    }
}
function* deleteDeliveryConfiguration({ payload }) {
    try {
        // do not use response, because its only a success message
        yield call(deleteConfig, payload);
        yield put(deleteDeliveryConfigurationSuccess(payload));
    } catch (error) {
        yield put(deleteDeliveryConfigurationFail(error));
    }
}

function* deliveryConfigurationSaga() {
    yield takeEvery(GET_DELIVERY_CONFIGURATION, fetchDeliveryConfiguration);
    yield takeEvery(SET_DELIVERY_CONFIGURATION, setDeliveryConfiguration);
    yield takeEvery(DELETE_DELIVERY_CONFIGURATION, deleteDeliveryConfiguration);
}

export default deliveryConfigurationSaga;